import {exportFilenameStem, formatAsJson, formatAsMarkdown} from './format'
import type {ExportableConversation, ExportFormat} from './types'

const MIME_TYPES = {
  json: 'application/json',
  markdown: 'text/markdown',
} as const

export interface ExportBlob {
  blob: Blob
  filename: string
}

export function buildExportBlob(conversation: ExportableConversation, format: ExportFormat): ExportBlob {
  const stem = exportFilenameStem(conversation.title)

  if (format === 'json') {
    return {blob: new Blob([formatAsJson(conversation)], {type: MIME_TYPES.json}), filename: `${stem}.json`}
  }

  return {blob: new Blob([formatAsMarkdown(conversation)], {type: MIME_TYPES.markdown}), filename: `${stem}.md`}
}

// Requires a DOM (`document`, `URL.createObjectURL`).
export async function downloadConversation(conversation: ExportableConversation, format: ExportFormat): Promise<void> {
  const {blob, filename} = buildExportBlob(conversation, format)
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  try {
    anchor.href = url
    anchor.download = filename
    anchor.style.display = 'none'
    document.body.appendChild(anchor)
    anchor.click()
  } finally {
    // `remove()` is a no-op if the anchor was never appended, so a throwing
    // `click()` cannot leak the node.
    anchor.remove()
    // Defer revocation so the click has a chance to start the download.
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }
}
